import {
    Breadcrumbs, Link as MuiLink, Toolbar, Typography
} from '@mui/material';
import { Loader, PageMessage } from '@tsp-ui/core/components';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './Page.module.scss';


export interface PageProps {
    breadcrumbs?: ReactNode[];
    children: ReactNode;
    className?: string;
    header: ReactNode;
    headerActions?: ReactNode;
    loading?: boolean;
    variant?: 'centered' | 'full';
}

export default function Page({
    breadcrumbs, children, className, header, headerActions, loading, variant
}: PageProps) {
    return (
        <main
            className={clsx(styles.main, className, {
                [styles.centered]: variant === 'centered'
            })}
        >
            <Toolbar
                className={styles.toolbar}
                disableGutters
            >
                <Typography
                    variant="h4"
                    component="h1"
                    align={variant === 'centered' ? 'center' : 'left'}
                    className={styles.header}
                >
                    {header}
                </Typography>

                <PageMessage className={styles.pageMessageContainer} />

                <div className={styles.headerActionsContainer}>
                    {headerActions}
                </div>
            </Toolbar>

            {breadcrumbs && (
                <Breadcrumbs
                    className={styles.breadcrumbs}
                    separator="›"
                >
                    {breadcrumbs.map((breadcrumb, index) => {
                        const to = getBreadcrumbTo(index, breadcrumbs.length);

                        return index < breadcrumbs.length - 1 ? (
                            <MuiLink
                                key={to}
                                component={Link}
                                to={to}
                                variant="body2"
                            >
                                {breadcrumb || '...'}
                            </MuiLink>
                        ) : (
                            <Typography
                                key="end"
                                variant="body2"
                            >
                                {breadcrumb || '...'}
                            </Typography>
                        );
                    })}
                </Breadcrumbs>
            )}

            {loading ? <Loader loading /> : children}
        </main>
    );
}

function getBreadcrumbTo(index: number, breadcrumbLength: number) {
    return Array(breadcrumbLength - 1 - index)
        .fill(0)
        .map(_ => '..')
        .join('/');
}

Page.defaultProps = {
    variant: 'full'
};
